import { Button, Card } from "@pushpress/pushpress-ui";
import React, { useMemo } from "react";
import { Interruption } from "../types";
import { INTERRUPTION_MESSAGES } from "../constants";
import { startCase, omitBy } from "lodash";

// Optional additional styles for the component
interface InterruptionProps {
  interruptionName: Interruption;
  data: Record<string, any>;
  confirm?: () => void;
  cancel?: () => void;
}

/**
 *
 * @param interruptionName - The name of the interruption
 * @param data - The data of the interruption
 * @returns
 */
const Interruption: React.FC<InterruptionProps> = ({
  interruptionName,
  data,
  confirm,
  cancel,
}) => {
  const filteredData = useMemo(
    () => omitBy(data, (_, key) => key.toLowerCase().includes("uuid")),
    [data],
  );

  return (
    <>
      <Card
        className="tw-px-4 tw-py-3 tw-mb-2 tw-rounded-lg tw-max-w-full tw-break-words tw-border tw-shadow-sm tw-pb-4"
        style={{ width: "60%" }}
      >
        <div className="tw-space-y-1">
          <div className="tw-mb-2">
            <div className="tw-font-bold tw-text-md">
              {INTERRUPTION_MESSAGES[interruptionName]}
            </div>
          </div>
          {Object.entries(filteredData).map(([k, v]) => (
            <div key={k}>
              <span className="tw-font-bold">{startCase(k)}: </span>
              <span>{v as string}</span>
            </div>
          ))}
        </div>
      </Card>
      {confirm && cancel && (
        <div className="tw-flex tw-gap-3 tw-mt-2 tw-pb-6">
          <Button color="primary" onClick={confirm}>
            Confirm
          </Button>
          <Button color="secondary" variant="outline" onClick={cancel}>
            Cancel
          </Button>
        </div>
      )}
    </>
  );
};

export default Interruption;
